import { slugify } from './slug.utils';

export function getCountySlug(countyName: string): string {
  return slugify(normalizeCountyName(countyName));
}

export function normalizeCountyName(name: string): string {
  if (!name) return '';
  const normalized = name
    .replace(/^Municipiul\s+/i, '')
    .replace(/^Judetul\s+/i, '')
    .trim();
  const mapping: Record<string, string> = {
    'MUNICIPIUL BUCURESTI': 'Bucuresti',
    'BUCURESTI': 'Bucuresti',
    'BISTRIŢA-NĂSĂUD': 'Bistrita-Nasaud',
    'CARAŞ-SEVERIN': 'Caras-Severin',
  };
  return mapping[name.toUpperCase()] ?? normalized;
}
